import { NgModule } from '@angular/core';

import { SharedModule } from '@shared';

import { NavbarComponent } from './navbar.component';

@NgModule({
    imports: [SharedModule],
    exports: [NavbarComponent],
    declarations: [NavbarComponent]
})
export class NavbarModule {}
